module.exports = __webpack_public_path__ + "media/images/arrow-r-b7603264ee816d1f967522df1a58b755.png";